module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-coco.fe53e3de.jpg";